  /* BraveWorld */
jQuery(document).ready(function($) {
  if($('div#tab-description > p').text().length < 3) {  // Checking the text inside a div
  	$('div#tab-description > p').hide();
  };
});
